import React from "react";
import { navigate, Location, useLocation } from "@reach/router";
import axios from "axios";

// import vanillaJS Potree libs, /!\ would be best with proper ES6 import
const Potree = window.Potree;
const THREE = window.THREE;
const TWEEN = window.TWEEN;

import "./Pointcloud.css";

function random(start, end) {
  return Math.random() * (end - start) + start;
}

export default class PointcloudNavigator extends React.Component {
  constructor(props) {
    super(props);
    this.potreeContainerDiv = React.createRef();
  }

  render() {
    return (
      <div
        id="potree-root"
        className="fixed w-screen h-screen top-0 left-0 bottom-0 right-0"
      >
        <div
          ref={this.potreeContainerDiv}
          className="potree_container w-screen h-screen"
        >
          <div id="potree_render_area"></div>
        </div>
      </div>
    );
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.hallfromexplore !== this.props.hallfromexplore;
  }

  componentDidMount() {
    // initialize Potree viewer
    const viewerElem = this.potreeContainerDiv.current;
    const viewer = new Potree.Viewer(viewerElem);
    const hall = this.props.hallfromexplore;

    const hallOrigins = {
      "1w": [-66.88572854764641, -16.90071115591502, -2.8304673516184033],
      "2w": [-53.261869835771044, -15.813246494822215, 13.946192506751084],
      "3w": [-95.66701075982257, -4.564554713981453, -3.9047538990785746],
      "4w": [-85.84960426542779, -11.022449492094143, -9.193076544983352],
      "5w": [-23.834254441691407, 36.08705887875037, -20.379967514568236],
    };

    const hallLookAt = {
      "1w": [-17.806796292892887, -10.289980282241238, -2.8598612073072687],
      "2w": [-54.00024206922881,-15.689879492751183,13.941814643975247],
      "3w": [-93.75984200974236, -4.596285133063312, -3.753294692699975],
      "4w": [-84.68735895962611, -10.871142176650423, -9.207420230629655],
      "5w": [-24.57378072514616, 34.67585460428121, -20.310748629110083],
    };

    // viewer.setEDLEnabled(true);
    viewer.useHQ = true;
    viewer.setFOV(80);
    viewer.setPointBudget(2.5 * 1000 * 1000);
    viewer.setClipTask(Potree.ClipTask.SHOW_INSIDE);
    viewer.loadSettingsFromURL();
    viewer.logarithmicDepthBuffer = true;

    // viewer.setControls(viewer.earthControls)
    viewer.setControls(viewer.fpControls);
    // viewer.setControls(viewer.orbitControls);

    // viewer.fpControls.lockElevation = true;

    // Load and add point cloud to scene
    const url = `/${hall}/metadata.json`; // do not forget to put your pointcloud data in the public/pointcloud/ folder
    Potree.loadPointCloud(url).then(
      (e) => {
        let scene = viewer.scene;
        let pointcloud = e.pointcloud;
        let material = pointcloud.material;

        material.activeAttributeName = "rgba";
        material.minSize = 1;
        material.pointSizeType = Potree.PointSizeType.ADAPTIVE;
        material.wireframe = true;

        viewer.scene.addPointCloud(pointcloud);
        pointcloud.scale.multiply(new THREE.Vector3(-1, 1, -1));

        //Setting initial position and view
        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.x_init &&
            this.props.location.state.y_init &&
            this.props.location.state.z_init
        ) {
          scene.view.position.set(
            this.props.location.state.x_init - 0.5,
            this.props.location.state.y_init - 0.5,
            this.props.location.state.z_init
          );
          scene.view.lookAt(
            new THREE.Vector3(
              this.props.location.state.x_init,
              this.props.location.state.y_init,
              this.props.location.state.z_init
            )
          );
        } else {
          scene.view.position.set(...hallOrigins[hall]);
          scene.view.lookAt(...hallLookAt[hall]);
        }

        viewer.fpControls.moveSpeed = 1;
        viewer.setMoveSpeed(5);

        // scene.scenePointCloud.position.set(0.04000000000000001, -0.023161633539355964, 0.9997317333824052);

        // const [min, max] = [
        //     { x: -0.6109316373465323, y: -0.9043269897436835, z: 0.636241569001960 },
        //     { x: -1.8665783242087732, y: 0.6856383768305048, z: -14.265427973376779 }];

        fetch("/api/posts")
          .then((data) => {
            if (data.ok) {
              return data.json();
            }
          })
          .then((postData) =>
            postData.forEach(({ username, body, location_data } = post) => {
              if (!location_data || location_data.hall !== hall) return;

              const { x, y, z } = location_data;

              scene.addAnnotation([x, y, z], {
                title: `'${body}' ~${username}`,
                radius: 1,
                actions: [
                  {
                    icon: Potree.resourcePath + "/icons/goto.svg",
                    onclick: function () {
                      navigate("/gallery");
                    },
                  },
                ],
              });
            })
          );

        window.scene = scene; // for debugging
        // viewer.fitToScreen();
      },
      (e) => console.err("ERROR: ", e)
    );
  }

  componentDidUpdate() {
    // If you want to update Potree View/other element upon render(), put it here
    this.potreeContainerDiv.current.innerHTML = "";
    this.componentDidMount();
  }
}
